import { Component, Inject } from '@angular/core';
import { NgIf } from '@angular/common';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AbstractFormComponent } from '@shared/components/abstracts/abstract-form.component';
import { PublicService } from '@shared/services/public.service';
import { HttpErrorResponse } from '@angular/common/http';
import { animate, style, transition, trigger } from '@angular/animations';
import { UserService } from '@shared/services/user.service';
import { DocumentData } from '@shared/interfaces/document-data';
import { ENVIRONMENT_CONFIG } from '@shared/injection-token/environment-config';
import { EnvironmentConfig } from '@shared/interfaces/environment-config';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-contact',
  imports: [ReactiveFormsModule, NgIf, TranslateModule],
  templateUrl: './contact.component.html',
  animations: [
    trigger('opacity', [
      transition(':enter', [
        style({
          opacity: 0,
        }),
        animate(
          '150ms',
          style({
            opacity: 1,
          })
        ),
      ]),
      transition(':leave', [
        style({
          opacity: 1,
        }),
        animate(
          '150ms',
          style({
            opacity: 0,
          })
        ),
      ]),
    ]),
    trigger('open', [
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateY(0.25rem)',
        }),
        animate(
          '200ms',
          style({
            opacity: 1,
            transform: 'translateY(0)',
          })
        ),
      ]),
      transition(':leave', [
        style({
          opacity: 1,
          transform: 'translateY(0)',
        }),
        animate(
          '150ms',
          style({
            opacity: 0,
            transform: 'translateY(0.25rem)',
          })
        ),
      ]),
    ]),
  ],
})
export class ContactComponent extends AbstractFormComponent {
  email = this.environmentConfig.config.email;
  isSendContactErrorMessage?: string;
  isOpen = false;

  constructor(
    @Inject(ENVIRONMENT_CONFIG) public environmentConfig: EnvironmentConfig,
    private publicService: PublicService<DocumentData>,
    private userService: UserService
  ) {
    const form = new FormGroup({
      firstName: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
      ]),
      lastName: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
      ]),
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/),
      ]),
      message: new FormControl('', [
        Validators.required,
        Validators.minLength(30),
      ]),
    });
    super(form);
    this.userService.getUser$().subscribe(user => {
      if (user) {
        const control = this.formGroup.get('email');
        if (control) {
          control.setValue(user.email);
        }
      }
    });
  }

  onCloseModal() {
    window.location.reload();
  }

  protected override onSubmit(): boolean {
    const email = this.formGroup.get('email');
    const firstName = this.formGroup.get('firstName');
    const lastName = this.formGroup.get('lastName');
    const message = this.formGroup.get('message');
    if (super.onSubmit() && email && firstName && lastName && message) {
      this.publicService
        .sendWebform({
          email: email.value,
          lastName: lastName.value,
          firstName: firstName.value,
          message: message.value,
        })
        .subscribe(
          () => {
            this.isOpen = true;
            this.isSendContactErrorMessage = undefined;
          },
          (err: HttpErrorResponse) => {
            this.onDisabled(false);
            this.isSendContactErrorMessage = err.error.error.message;
          }
        );
      return true;
    }
    return false;
  }
}
